import { Checkbox, Radio } from "@material-ui/core";
import React, { ReactElement } from "react";
import styled from "styled-components/macro";

const TileDiv = styled.div`
	margin: 10px;
	text-align: center;
`;

const Card = styled.div`
	position: relative;
	background-color: #fff;
	box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2);
	width: 132px;
	height: 132px;
	margin-bottom: 10px;
	font-weight: bold;
	background-image: url("missing.png");
	background-size: 40px;
	background-repeat: no-repeat;
	background-position: center;
`;
const SelectionRadio = styled(Radio)`
	position: absolute;
	top: 3px;
	left: 3px;
`;

const SelectionCheckbox = styled(Checkbox)`
	position: absolute;
	top: 3px;
	left: 3px;
`;

interface TileProps {
	index: number;
	label: string;
	thumbUrl?: string;
	type: "checkbox" | "radio";
	checked?: boolean;
	onClick: (index: number) => void;
}

function Tile(props: TileProps): ReactElement {
	const handleClick = () => {
		props.onClick(props.index);
	};

	const style = props.thumbUrl ? { backgroundImage: `url('${props.thumbUrl}'')` } : {};

	return (
		<TileDiv onClick={handleClick}>
			<Card style={style}>
				{props.type === "radio" && <SelectionRadio value={props.index} color="primary" />}
				{props.type === "checkbox" && (
					<SelectionCheckbox color="primary" checked={props.checked} onChange={handleClick} />
				)}
			</Card>
			{props.label}
		</TileDiv>
	);
}

export default Tile;
